import type { GetModalRedirectStateProps } from "./page-item-context-gate.type";
import type { RouterLocationState } from "@/modules/router";

import { convertContextPath } from "@/modules/organization/organization-context";

export const getModalRedirectState = ({
  state,
  modalState,
  itemContext,
}: GetModalRedirectStateProps): RouterLocationState => {
  const redirectState = {
    ...state,
    pageModal: { ...state.pageModal, ...modalState },
  };

  const backgroundLocation = redirectState.pageModal.backgroundLocation;

  if (!backgroundLocation) return redirectState;

  const newPath = convertContextPath({
    pathname: backgroundLocation.pathname,
    context: itemContext.slug,
  });

  if (!newPath) return redirectState;

  return {
    ...redirectState,
    pageModal: {
      ...redirectState.pageModal,
      backgroundLocation: { ...backgroundLocation, pathname: newPath },
    },
  };
};
